/* script */
//
//
//
//
//
//
//
//
//
//
//


/**
 * This component renders a content hub card.
 *
 * @category ui.components.cards
 * @exports ContentHub
 */
const __vue_script__ = {
    name: 'ContentHub',
    props: {
        contentHub: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            subtitle: this.$i18n.t('content_hubs.created', [this.$utils.time.timeFromNow(this.contentHub.created)])
        };
    },

    methods: {
        /**
         * Returns the tooltip config
         *
         * @param {String} content the tooltip string to display
         *
         * @return {Object|null} the config
         */
        getTooltipConfig(content) {
            return {
                content: content,
                delay: { show: 2000, hide: 300 },
                placement: 'bottom',
                container: false
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card has-action content-hub",attrs:{"href":_vm.$services.contentHub.getUrl(_vm.contentHub.id, _vm.contentHub.node)}},[_c('div',{staticClass:"content-text"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getTooltipConfig(_vm.contentHub.name)),expression:"getTooltipConfig(contentHub.name)"}],staticClass:"title"},[_vm._v(_vm._s(_vm.contentHub.name))]),_c('small',{staticClass:"sub"},[_vm._v(_vm._s(_vm.subtitle))]),_c('footer',[_c('i',{staticClass:"icon-gauge"}),_c('span',[_vm._v(_vm._s(_vm.contentHub.workspaces.length))]),_c('i',{staticClass:"icon-rocket"}),_c('span',[_vm._v(_vm._s(_vm.contentHub.webinars.length))])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContentHub.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__